module.exports = __webpack_public_path__ + "img/5-5.9f112d09.svg";